import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

function Register() {
  const navigate = useNavigate();

  const handleLoginCLick = () => {
    navigate('/Login')
  }
  return (
    <div className="register-container">
      <h4 className="content-title">Register</h4>
      <p className="content-text">
        Log in to the application with the e-mail and password you received at the end of submitting the application or question
      </p>
      <div className="fill-opt1">
        <p htmlFor="">E-mail</p>
        <input
          type="text"
          name="abuseLocation"
          required
        />
      </div>
      <div className="fill-opt1">
        <p htmlFor="">Password</p>
        <input
          type="password"
          name="password"
          required
        />
      </div>
      <button className='Nextbtn'>Continiue</button>
      <p className="content-text alreadyregistered">
        If you already have a completed report, you can go through authorization.
        Log in to the application with the e-mail and password you received at the end of submitting the application or question
      </p>
      <button className='Nextbtn' onClick={handleLoginCLick}>Log in</button>
    </div>
  )
}

export default Register